<template>
  <div
    class="drawer-wrapper"
    :class="{ active: status }"
    :style="`z-index: ${zIndex}`"
  >
    <div
      class="drawer-fade"
      :class="{ active: status }"
      :style="`transition: ${time}s all linear; z-index: ${zIndex}`"
      v-on:click="beforeClose($event)"
    ></div>
    <div
      :class="`drawer-box drawer-${direction} ${status} ${
        closing ? 'closing' : ''
      } ${drawerNewOrder ? 'new-order' : ''}`"
      :style="`transition: ${time}s all ease-in-out, transform 0s; height: ${height}; z-index: ${
        zIndex + 10
      }; display: ${!!display ? 'flex' : 'none'} `"
    >
      <div>
        <div class="drawer-title" :style="`${styleTitle};`">
          <span
            v-if="goBack"
            class="fs-16 cursor-pointer"
            @click="back ? prev() : beforeClose($event, true)"
          >
            <i class="fal fa-chevron-left fw-400"></i>
          </span>
          <p
            v-if="title"
            class="title-text"
            style="margin-right: -15px"
            :title="title"
          >
            {{ this.title }}
          </p>
          <span
            v-if="haveX"
            @click="beforeClose($event, true)"
            class="fs-16 cursor-pointer"
            ><i :class="closebtn"></i
          ></span>
        </div>

        <div
          class="drawer-content"
          :class="!(showFooter && $slots.footer) ? 'mb_0' : 'has_footer'"
          :style="`overflow-y: ${overflow};`"
          id="drawerContainer"
        >
          <slot name="default"></slot>
        </div>

        <div v-if="showFooter && $slots.footer" class="drawer-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppBridge from '@/plugins/app';
import store from '@/store';

export default {
  data() {
    return {
      status: '',
      display: true,
      showFooter: true,
      closing: false,
    };
  },
  props: {
    open: { default: '' },
    close: { default: '' },
    title: { default: '' },
    direction: { default: 'right' },
    time: { default: '.5' },
    height: { default: '100%' },
    overflow: { default: 'auto' },
    zIndex: { default: 2501 },
    haveX: { default: true },
    closebtn: { default: 'fal fa-times' },
    styleTitle: { default: '' },
    closeValidation: { default: null },
    closeInFade: { default: true },
    goBack: { type: Boolean, default: false },
    back: { type: Boolean, default: false },
    drawerNewOrder: { type: Boolean, default: null },
  },
  methods: {
    prev() {
      this.$emit('onBack');
    },
    async beforeClose(e, closeInX) {
      if (closeInX || this.closeInFade) {
        if (!this.closeValidation) {
          return (this.status = false);
        }

        if (await this.closeValidation(e)) {
          this.status = false;
        }
      }
    },
    scrollTo(targetId, duration, options) {
      this.$scrollTo(targetId, duration, {
        ...options,
        container: '#drawerContainer',
      });
    },
    handleOrientationChange() {
      const orientation = window.screen.orientation.type;
      if (orientation !== 'portrait-primary') {
        this.display = false;

        setTimeout(() => {
          this.display = true;
        }, 1000);
      }
    },
  },
  mounted() {
    this.display = false;
    setTimeout(() => {
      this.display = true;
    }, 500);
    window.addEventListener('orientationchange', this.handleOrientationChange);
    if (AppBridge.isApp()) {
      AppBridge.listen('keyboardDidShow', () => {
        this.showFooter = false;
      });

      AppBridge.listen('keyboardDidHide', () => {
        this.showFooter = true;
      });
    }
  },
  watch: {
    open() {
      this.status = 'opened';
      store.commit('store/setHasDrawerOpened', true);
    },
    close() {
      this.status = '';
      store.commit('store/setHasDrawerOpened', false);
    },
    status(newVal) {
      if (newVal === 'opened') {
        this.$emit('onOpen');
        return;
      }
      this.closing = true;
      this.$emit('onClose');
    },
  },
  computed: {
    ...mapState({
      hasDrawerOpened: (state) => state.store.hasDrawerOpened,
    }),
  },
};
</script>

<style scoped>
.drawer-box {
  position: fixed;
  width: 100%;
  overflow-x: hidden;
  left: 0;
  top: 0;
}
.drawer-box:not(.drawer-center) {
  background: var(--box);
}
.drawer-title:not(:empty) {
  color: var(--default);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px 10px;
  z-index: 1;
}
.drawer-title .title-text {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  padding: 0 45px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 20px;
}
.drawer-fade {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  opacity: 0;
  pointer-events: none;
}
.drawer-fade.active {
  opacity: 1;
  pointer-events: unset;
}
.drawer-box.drawer-center {
  opacity: 0;
  top: -100vh;
  width: 450px;
  max-width: 100%;
  height: auto !important;
  justify-content: center;
  padding: 0 5px;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 0;
  border-radius: 5px;
  pointer-events: none;
}
.drawer-box.drawer-center > div {
  background: var(--box);
  border-radius: 5px;
  max-height: calc(100vh - 60px);
  overflow-y: auto;
}
.drawer-box.drawer-center.opened {
  opacity: 1;
  top: 0 !important;
  pointer-events: initial;
}
.drawer-box.drawer-right {
  right: -100vw;
  left: auto;
}
.drawer-box.drawer-right.opened {
  right: 0 !important;
}
.drawer-box.drawer-left {
  left: -100vw;
}
.drawer-box.drawer-left.opened {
  left: 0 !important;
}
.drawer-box.drawer-top {
  top: -100vh;
}
.drawer-box.drawer-top.opened {
  top: 0 !important;
}
.drawer-content {
  padding: 20px 15px;
  overflow-x: hidden;
}
.drawer-box.drawer-right .drawer-content,
.drawer-box.drawer-left .drawer-content {
  height: calc(100vh - 175px);
}
.drawer-box.drawer-right .drawer-content:not(.has_footer),
.drawer-box.drawer-left .drawer-content:not(.has_footer) {
  height: calc(100vh - 90px);
}
.drawer-box.drawer-center .drawer-content {
  padding: 15px;
  position: relative;
}

@media screen and (max-width: 991px) {
  .drawer-box.drawer-top .drawer-content {
    height: calc(100vh - 120px);
  }

  .drawer-content {
    padding: 20px 15px 60px;
    max-height: -webkit-fill-available;
  }
  .drawer-bottom .drawer-content {
    padding: 20px 15px 30px;
  }
}
.drawer-wrapper.active {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
}
.drawer-box {
  display: flex;
  flex-direction: column;
  height: 80vh;
  overflow: hidden;
}
.drawer-footer {
  background: var(--box);
  width: 100%;
  box-shadow: 0px 0px 6px #00000029;
  padding: 20px 15px;
  z-index: 1;
  position: absolute;
  bottom: 0;
}
.drawer-box.drawer-bottom .drawer-title {
  color: var(--label-secondary);
  padding: 20px;
  border-bottom: 1px solid #ffffff17;
}
@media screen and (max-width: 991px) {
  .drawer-box.drawer-center {
    max-width: 90%;
  }
  .drawer-box.drawer-top .drawer-content {
    height: calc(100vh - 120px);
  }
  .drawer-box.drawer-bottom {
    bottom: -100vh;
    top: auto;
    height: auto;
    transition: none !important;
  }
  .drawer-box.drawer-bottom.opened {
    bottom: 0 !important;
    height: 100%;
  }
  .drawer-box.drawer-bottom.opened .drawer-content {
    margin-bottom: 30px;
  }
}
@media screen and (min-width: 992px) {
  .container-after-titlebar .drawer-box:not(.drawer-center) .drawer-box {
    width: 100% !important;
  }
  .drawer-box.drawer-bottom {
    transform: translateY(-100%);
    border-radius: 5px;
  }
  .drawer-box.drawer-bottom.closing {
    animation: drawer-closing 0.75s ease-in-out;
  }
  .drawer-box.drawer-bottom.opened {
    transform: translateY(55px);
    animation: drawer-opening 0.5s ease;
  }

  .drawer-box,
  .drawer-box.drawer-right > .drawer-right {
    width: 30% !important;
  }
  .drawer-box.drawer-top {
    width: 100vw !important;
  }
  .drawer-box.drawer-bottom {
    right: 0;
    margin: auto;
  }

  @-webkit-keyframes drawer-opening {
    from {
      -webkit-transform: translateY(-100%);
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(55px);
      opacity: 1;
    }
  }

  @keyframes drawer-opening {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    25% {
      opacity: 0;
    }
    100% {
      transform: translateY(55px);
      opacity: 1;
    }
  }

  @-webkit-keyframes drawer-closing {
    from {
      -webkit-transform: translateY(55px);
      opacity: 1;
    }
    25% {
      opacity: 0;
    }
    to {
      -webkit-transform: translateY(-100%);
      opacity: 0;
    }
  }

  @keyframes drawer-closing {
    from {
      transform: translateY(55px);
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    to {
      transform: translateY(-100%);
      opacity: 0;
    }
  }
}
</style>
